import { handleExternalLink } from '@/utils/link-props';
import { Box, Divider, IconArrowLeft, Link, LinkProps } from '@cmpsr/components';

export default function DashboardLink(props: LinkProps) {
  return (
    <Box
      pt="spacer-4"
      px={{ base: 'spacer-4', md: 'spacer-8', lg: 'spacer-16', xl: 'spacer-24', xxl: 'spacer-32' }}
      maxWidth="1440px"
      marginX="auto"
    >
      <Link size="l" leadingIcon={<IconArrowLeft />} {...handleExternalLink(props)}>
        {props.children}
      </Link>
      <Divider mt={{ base: 'spacer-4', lg: 'spacer-5' }} />
    </Box>
  );
}
